export default __webpack_public_path__ + "static/ga-aee8b77340402d9a15332f7794d983da.png";